import React from 'react';
import './ProfileCard.css'

const ProfileCard = ({
  user
}) => {
  return (
    <div className="container profilCard" style={{marginTop:50}}>
      <div className="center profileIcon">
        <h4>BIO</h4>
        <i className="material-icons">account_circle</i>
      </div>
      <div className="section">
        <div className="row">
          <div className="col s12 m6">
            <div className="icon-block">
              <h5 className="" style={{color: '#373435'}}>First Name: <span className="userProperty">{user.firstname}</span></h5>
              <h5 className="" style={{color: '#373435'}}>Email: <span className="userProperty">{user.email}</span></h5>
              <h5 className="" style={{color: '#373435'}}>Date of birth: <span className="userProperty">{user.dob}</span></h5>


            </div>
          </div>

          <div className="col s12 m6">
            <div className="icon-block">
              <h5 className="" style={{color: '#373435'}}>Last Name: <span className="userProperty">{user.lastname}</span></h5>
              <h5 className="" style={{color: '#373435'}}>Phone: <span className="userProperty">{user.phonenumber}</span></h5>
              <h5 className="" style={{color: '#373435'}}>Gender: <span className="userProperty">{user.gender}</span></h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfileCard;